import React, { FC, ReactNode } from 'react';

import css from './style.module.scss';
import classNames from 'classnames';

interface IProps {
  children: ReactNode;
  isMobile?: boolean;
}

const Page: FC<IProps> = ({ children, isMobile }) => {
  return (
    <div
      className={classNames(css.page, {
        [css.isMobile]: isMobile,
      })}
    >
      {children}
    </div>
  );
};

export default Page;
